export enum SegmentationShortcutType {
    SWITCH_TO_NEXT_SEGMENT = "SWITCH_TO_NEXT_SEGMENT", // no meta
    SWITCH_TO_PREVIOUS_SEGMENT = "SWITCH_TO_PREVIOUS_SEGMENT", // no meta
    SWITCH_TO_NEXT_TARGET = "SWITCH_TO_NEXT_TARGET", // no meta
    SWITCH_TO_PREVIOUS_TARGET = "SWITCH_TO_PREVIOUS_TARGET", // no meta
    DELETE_ANNOTATION_DOT = "DELETE_ANNOTATION_DOT", // no meta
    CLEAR_CURRENT_TYPE = "CLEAR_CURRENT_TYPE", // no meta
    CLEAR_ALL = "CLEAR_ALL", // no meta
}